export default "__VITE_ASSET__CwkKHyza__"